<script>
import { computed, ref } from '@vue/composition-api'
import {
  mdiInformation,
} from '@mdi/js'
import { formatDate } from '@core/utils/filter'

export default {
  name: 'Comments',
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const formatDateShort = (date, option) => formatDate(date, option)
    const tooltip = ref(false)

    const hover = () => {
      if (props.comments.length) {
        tooltip.value = true
      }
    }
    const leave = () => {
      tooltip.value = false
    }

    return {
      icons: {
        mdiInformation,
      },
      formatDateShort,
      hover,
      leave,
      tooltip,
    }
  },
}
</script>

<template>
  <span>
    <v-icon
      v-if="comments.length"
      x-small
      color="info"
      class="ml-2"
      @mouseover="hover"
      @mouseleave="leave"
    >
      {{ icons.mdiInformation }}
    </v-icon>
    <v-tooltip
      v-model="tooltip"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        ></span>
      </template>
      <template>
        <div>
          <p
            v-for="comment in comments"

            :key="comment.id"
          >
            <span class="mr-2">{{ comment.user ? comment.user.code : '' }}</span>:
            <span
              v-if="comment.date_record || comment.created_at"
              class="mr-2"
            >{{ formatDateShort((comment.date_record ? comment.date_record : (comment.created_at || null)), {
              month: 'numeric',
              day: 'numeric',
            }) }}</span>
            <span class="mr-2">{{ comment.comment }}</span>
          </p>
        </div>
      </template>
    </v-tooltip>
  </span>
</template>

<style scoped lang="scss">

</style>
